import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'flattenObject',
    standalone: false
})
export class FlattenObjectPipe implements PipeTransform {

    transform(items: any[], column): any {
        let e;
        let column_key;
        column_key = column.data;
        column_key.split(".").map((x) => {
            e = e ? e[x] : items[x];
        });
        if (column.price_format) {
            e = `$ ${Number(e.toFixed(2)).toLocaleString()}`;
        }
        return e;
    }
}
